import { useEffect } from 'react';
import { Provider, useSelector } from 'react-redux';
import { store } from '@/state/store';
import type { RootState } from '@/state/store';
import { syncSystem } from '@/state/themeSlice';
import { useAppDispatch } from '@/hooks/useAppDispatch';
import { AppRouter } from '@/routes';
import { AuthInitializer } from '@/components/auth/AuthInitializer';

/** Applies/removes the 'dark' class on <html> based on resolved theme. */
const ThemeManager = () => {
  const dispatch = useAppDispatch();
  const { mode, resolved } = useSelector((s: RootState) => s.theme);

  useEffect(() => {
    const root = document.documentElement;
    if (resolved === 'dark') {
      root.classList.add('dark');
    } else {
      root.classList.remove('dark');
    }
  }, [resolved]);

  // Keep 'system' mode in sync with OS preference changes
  useEffect(() => {
    if (mode !== 'system') return;
    const mq = window.matchMedia('(prefers-color-scheme: dark)');
    const handler = () => dispatch(syncSystem());
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [mode, dispatch]);

  return null;
};

const App = () => (
  <Provider store={store}>
    <ThemeManager />
    {/* Silent refresh auth bootstrapping (added based on Dinisuru's request) */}
    <AuthInitializer>
      <AppRouter />
    </AuthInitializer>
  </Provider>
);

export default App;
